/**
 * GENERATED FILE. DO NOT EDIT BY HAND.
 * Source of truth: tools/fingerprint_emojis.json
 * Regenerate with: make gen-fingerprint  (or  cd web && npm run gen:fingerprint)
 *
 * Ordered emoji table used to derive the export-session fingerprint.
 * The order is significant; changing it breaks compatibility with any
 * already-generated fingerprint and with the Flutter counterpart.
 */
export const FINGERPRINT_EMOJIS: readonly string[] = Object.freeze([
  "🦊",
  "🐻",
  "🐼",
  "🦁",
  "🐯",
  "🐰",
  "🐹",
  "🐧",
  "🐸",
  "🐢",
  "🦎",
  "🐙",
  "🦉",
  "🦀",
  "🐠",
  "🐳",
  "🌙",
  "⭐",
  "☀️",
  "☁️",
  "🌈",
  "⚡",
  "❄️",
  "🔥",
  "🌸",
  "🌻",
  "🌳",
  "🍀",
  "🌵",
  "🍎",
  "🍇",
  "🍄",
]);
